export const normalizeUser = (user) => ({
  id: user.id ?? user.Id,
  userName: user.userName ?? user.UserName,
  email: user.email ?? user.Email,
  name: user.name ?? user.Name,
  profilePhotoUrl: user.profilePhotoUrl ?? user.ProfilePhotoUrl,
  bio: user.bio ?? user.Bio,
  followersCount: user.followersCount ?? user.FollowersCount ?? 0,
  followingCount: user.followingCount ?? user.FollowingCount ?? 0,
  postsCount: user.postsCount ?? user.PostsCount ?? 0,
  userType: user.userType ?? user.UserType,
  rookieType: user.rookieType ?? user.RookieType,
  profileCompleted: user.profileCompleted ?? user.ProfileCompleted,
  interestedFields: user.interestedFields ?? user.InterestedFields,
  lookingFor: user.lookingFor ?? user.LookingFor,   // <-- Add this
  state: user.state ?? user.State,
  city: user.city ?? user.City,
  videoPitchUrl: user.videoPitchUrl ?? user.VideoPitchUrl,
  //contactNumber: user.contactNumber ?? user.ContactNumber,
dateOfBirth: user.dateOfBirth ?? user.DateOfBirth,
gender: user.gender ?? user.Gender,
});